<app-menu-toggle
  tooltip="Collections Info"
  icon="eventData"
  [active]="showObjectsInfo"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
